"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRTL = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
// eslint-disable-next-line import/prefer-default-export
var isRTL = function isRTL() {
  if ((typeof window === "undefined" ? "undefined" : (0, _typeof2.default)(window)) === 'object') {
    return document.dir === 'rtl';
  }
  return false;
};
exports.isRTL = isRTL;